






















import { Component, Vue, Prop, Ref, Watch } from "vue-property-decorator";
import Chart from "chart.js";
import { max, min } from "lodash";

@Component
export default class Card extends Vue {
  @Prop({ type: Object, required: true }) item!: object;
  @Ref("canvas") canvas!: HTMLCanvasElement;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: "light" }) gradientVariant!: "dark" | "light";
  @Prop({ default: () => [] }) data!: number[];
  @Prop({ default: false }) twoCards!: boolean;
  chart: null | Chart = null;


  @Watch("loading")
  watchLoading() {
    if (!this.loading && this.data) {
      // this.initChart();
    }
  }
 numberWithCommas(n: number) {
  let parts= n.toString().split(".");
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  }
  getGradientColors() {
    if (this.gradientVariant === "light") {
      return [
        [58, 95, 119],
        [195, 230, 195],
      ];
    }

    return [
      [60, 93, 114],
      [138, 113, 119],
    ];
  }

  getGradient(ctx: CanvasRenderingContext2D) {
    const [from, to] = this.getGradientColors();
    const gradientStroke = ctx.createLinearGradient(200, 0, 50, 0);
    gradientStroke.addColorStop(0, `rgb(${from.join(",")})`);
    gradientStroke.addColorStop(1, `rgb(${to.join(",")})`);
    const gradientFill = ctx.createLinearGradient(200, 0, 50, 0);
    gradientFill.addColorStop(0, `rgba(${[...from, 0.5].join(",")})`);
    gradientFill.addColorStop(1, `rgba(${[...to, 0.5].join(",")})`);
    return [gradientStroke, gradientFill];
  }

  initChart() {
    const ctx = this.canvas.getContext("2d");
    if (!ctx || !this.data) {
      return;
    }

    const [stroke, fill] = this.getGradient(ctx);
    this.chart = new Chart(this.canvas, {
      type: "line",
      data: {
        labels: this.data.map((val, i) => `week ${i + 1}`),
        datasets: [
          {
            borderColor: stroke,
            pointBorderColor: stroke,
            pointBackgroundColor: stroke,
            pointHoverBackgroundColor: stroke,
            pointHoverBorderColor: stroke,
            pointRadius: 0,
            fill: true,
            backgroundColor: fill,
            borderWidth: 4,
            data: this.data,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        events: [],
        legend: {
          display: false,
        },
        layout: {
          padding: {
            top: 10,
          },
        },
        scales: {
          yAxes: [
            {
              display: false,
              ticks: {
                suggestedMin: 0,
              },
            },
          ],
          xAxes: [
            {
              display: false,
              ticks: {
                suggestedMin: min(this.data),
              },
            },
          ],
        },
      },
    });
  }

}
